<template>
  <div>
    <b-row no-gutters>
      <b-col cols="12">
        <BuyProgress
          v-if="
            apartment &&
            customer != 'clab' &&
            ['default', 'redondo'].includes(template)
          "
          :apartment="apartment"
          :country="country"
        ></BuyProgress>
      </b-col>
      <b-col cols="12">
        <div @click="showPhoto" v-if="photos">
          <b-carousel
            class="apartment-images my-4"
            v-model="carouselPosition"
            v-if="photos.length > 0"
            :style="{ textShadow: '0px 0px 2px #000', minHeight: '100px' }"
            fade
            controls
          >
            <b-carousel-slide
              v-for="(photo, key) in photos"
              :key="key"
              v-bind:style="{
                background:
                  'url(' +
                  photo.url
                    .trim()
                    .replace(/ /g, '%20')
                    .replace(/\(/g, '%28')
                    .replace(/\)/g, '%29') +
                  ')',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
              }"
            ></b-carousel-slide>
          </b-carousel>
          <b-modal
            id="modal-photo"
            size="xl"
            :interval="0"
            centered
            hide-header
            body-bg-variant="transparent"
            content-class="border-0 bg-transparent"
            hide-footer
          >
            <b-carousel v-model="setedPhoto" fade controls>
              <b-carousel-slide
                v-for="(photo, key) in photos"
                :img-src="photo.url"
                :key="key"
              ></b-carousel-slide>
            </b-carousel>
          </b-modal>
        </div>
        <div v-if="photos" class="text-right small text-dark open-photo">
          <i v-if="photos.length > 0"
            >*Presiona en las fotos para verlas completas</i
          >
        </div>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col cols="12" v-if="!hideData(apartment.asset_type)">
        <b-row class="my-5">
          <b-col cols="12" lg="3" class="my-2">
            <div class="d-flex align-items-center mr-2">
              <span class="detail-element">
                <div class="symbol symbol-45 symbol-light mr-4 flex-shrink-0">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-lg svg-icon-info">
                      <font-awesome-icon :icon="['fal', 'bed']" size="lg" />
                    </span>
                  </div>
                </div>
                <div v-if="['cuadrado'].includes(template)">
                  <div class="text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.bedrooms }} Dormitorio{{
                      apartment.bedrooms > 1 ? "s" : ""
                    }}
                  </div>
                </div>
                <div v-else>
                  <div class="h4 text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.bedrooms }}
                  </div>
                  <div class="font-size-sm text-muted font-weight-bold">
                    Dormitorio{{ apartment.bedrooms > 1 ? "s" : "" }}
                  </div>
                </div>
              </span>
            </div>
          </b-col>
          <b-col cols="12" lg="3" class="my-2">
            <div class="d-flex align-items-center mr-2">
              <span class="detail-element">
                <div class="symbol symbol-45 symbol-light mr-4 flex-shrink-0">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-lg svg-icon-info">
                      <font-awesome-icon :icon="['fal', 'bath']" size="lg" />
                    </span>
                  </div>
                </div>
                <div v-if="['cuadrado'].includes(template)">
                  <div class="text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.bathrooms }} Baño{{
                      apartment.bathrooms > 1 ? "s" : ""
                    }}
                  </div>
                </div>
                <div v-else>
                  <div class="h4 text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.bathrooms }}
                  </div>
                  <div class="font-size-sm text-muted font-weight-bold">
                    Baño{{ apartment.bathrooms > 1 ? "s" : "" }}
                  </div>
                </div>
              </span>
            </div>
          </b-col>
          <b-col cols="12" lg="3" v-if="apartment.parking_lots" class="my-2">
            <div class="d-flex align-items-center mr-2">
              <span class="detail-element">
                <div class="symbol symbol-45 symbol-light mr-4 flex-shrink-0">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-lg svg-icon-info">
                      <font-awesome-icon
                        :icon="['fal', 'car-garage']"
                        size="lg"
                      />
                    </span>
                  </div>
                </div>
                <div v-if="['cuadrado'].includes(template)">
                  <div class="text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.parking_lots }} Estacionamiento{{
                      apartment.parking_lots > 1 ? "s" : ""
                    }}({{ apartment.parking_lots_data }})
                  </div>
                </div>
                <div v-else>
                  <div class="h4 text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.parking_lots }}
                    <small>({{ apartment.parking_lots_data }})</small>
                  </div>
                  <div class="font-size-sm text-muted font-weight-bold">
                    Estacionamiento{{ apartment.parking_lots > 1 ? "s" : "" }}
                  </div>
                </div>
              </span>
            </div>
          </b-col>
          <b-col cols="12" lg="3" v-if="apartment.cellars" class="my-2">
            <div class="d-flex align-items-center mr-2">
              <span class="detail-element">
                <div class="symbol symbol-45 symbol-light mr-4 flex-shrink-0">
                  <div class="symbol-label">
                    <span class="svg-icon svg-icon-lg svg-icon-info">
                      <font-awesome-icon
                        :icon="['fal', 'warehouse-alt']"
                        size="lg"
                      />
                    </span>
                  </div>
                </div>
                <div v-if="['cuadrado'].includes(template)">
                  <div class="text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.cellars }} Bodega{{
                      apartment.cellars > 1 ? "s" : ""
                    }}({{ apartment.cellars_data }})
                  </div>
                </div>
                <div v-else>
                  <div class="h4 text-dark-75 font-weight-bolder mb-0">
                    {{ apartment.cellars }}
                    <small>({{ apartment.cellars_data }})</small>
                  </div>
                  <div class="font-size-sm text-muted font-weight-bold">
                    Bodega{{ apartment.cellars > 1 ? "s" : "" }}
                  </div>
                </div>
              </span>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="country == 0">
      <b-col cols="12" class="d-lg-none">
        <b-table-simple borderless class="py-3 table-areas">
          <b-tr>
            <b-td class="px-0" v-if="!hideData(apartment.asset_type)">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.covered_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 65%">Área</div>
                <div style="font-size: 65%">Techada</div>
              </b-alert>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="px-2" v-if="!hideData(apartment.asset_type)">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.free_surface
                    )
                  }}<small>m</small>
                </div>
                <div style="font-size: 65%">Área</div>
                <div style="font-size: 65%">Libre</div>
              </b-alert>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="px-0">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.total_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 65%">Área</div>
                <div style="font-size: 65%">Total</div>
              </b-alert>
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-col>
      <b-col cols="12" class="d-none d-lg-block">
        <b-table-simple class="py-3 table-areas" borderless>
          <b-tr>
            <b-td
              :class="{
                'px-0': true,
                'visibility-0': hideData(apartment.asset_type),
              }"
            >
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  <b
                    >{{
                      new Intl.NumberFormat("es-CL").format(
                        apartment.covered_surface
                      )
                    }}<small>m<sup>2</sup></small></b
                  >
                </div>
                <div style="font-size: 100%">Área Techada</div>
              </b-alert>
            </b-td>
            <b-td class="px-2" v-if="!hideData(apartment.asset_type)">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  <b
                    >{{
                      new Intl.NumberFormat("es-CL").format(
                        apartment.free_surface
                      )
                    }}<small>m<sup>2</sup></small></b
                  >
                </div>
                <div style="font-size: 100%">Área Libre</div>
              </b-alert>
            </b-td>
            <b-td class="px-0">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  <b
                    >{{
                      new Intl.NumberFormat("es-CL").format(
                        apartment.total_surface
                      )
                    }}<small>m<sup>2</sup></small></b
                  >
                </div>
                <div style="font-size: 100%">Área Total</div>
              </b-alert>
            </b-td>
            <b-td
              :class="{
                'px-0 visibility-0': true,
                'd-none': !hideData(apartment.asset_type),
              }"
            >
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  <b
                    >{{
                      new Intl.NumberFormat("es-CL").format(
                        apartment.total_surface
                      )
                    }}<small>m<sup>2</sup></small></b
                  >
                </div>
                <div style="font-size: 100%">Área Venta</div>
              </b-alert>
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="12" class="d-lg-none">
        <b-table-simple
          borderless
          class="py-3 table-areas w-100"
          v-if="country == 0"
        >
          <b-tr>
            <b-td class="px-0" v-if="!hideData(apartment.asset_type)">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.useful_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 65%">Superficie</div>
                <div style="font-size: 65%">Útil</div>
              </b-alert>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="px-2" v-if="!hideData(apartment.asset_type)">
              <b-alert
                v-if="apartment.asset_type == 'CASA'"
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.terrain_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 0.8em">Superficie</div>
                <div style="font-size: 0.8em">Terreno</div>
              </b-alert>
              <b-alert
                v-else
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.terrace_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 0.8em">Superficie</div>
                <div style="font-size: 0.8em">Terraza</div>
              </b-alert>
            </b-td>
          </b-tr>
          <b-tr>
            <b-td class="px-0">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.2em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.total_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div style="font-size: 65%">Superficie</div>
                <div style="font-size: 65%">Total</div>
              </b-alert>
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-col>
      <b-col cols="12" class="d-none d-lg-block">
        <b-table-simple class="py-3 table-areas" borderless>
          <b-tr>
            <b-td class="px-0" v-if="!hideData(apartment.asset_type)">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.useful_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div class="label" style="font-size: 0.8em">Superficie</div>
                <div class="label" style="font-size: 0.8em">Útil</div>
              </b-alert>
            </b-td>
            <b-td class="px-2" v-if="!hideData(apartment.asset_type)">
              <b-alert
                v-if="apartment.asset_type == 'CASA'"
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.terrain_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div class="label" style="font-size: 0.8em">Superficie</div>
                <div class="label" style="font-size: 0.8em">Terreno</div>
              </b-alert>
              <b-alert
                v-else
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.terrace_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div class="label" style="font-size: 0.8em">Superficie</div>
                <div class="label" style="font-size: 0.8em">Terraza</div>
              </b-alert>
            </b-td>
            <b-td v-if="'ACCION' !== apartment.asset_type" class="px-0">
              <b-alert
                show
                variant="faded"
                class="area-element h-100 m-0 text-center"
              >
                <div style="font-size: 1.3em">
                  {{
                    new Intl.NumberFormat("es-CL").format(
                      apartment.total_surface
                    )
                  }}<small>m<sup>2</sup></small>
                </div>
                <div class="label" style="font-size: 0.8em">Superficie</div>
                <div class="label" style="font-size: 0.8em">Total</div>
              </b-alert>
            </b-td>
          </b-tr>
        </b-table-simple>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col cols="12">
        <b-progress
          v-if="
            apartment.progress &&
            apartment.progress >= 0 &&
            template == 'default'
          "
          :max="100"
          class="rounded-0 apartment-progress"
        >
          <div
            class="w-100 text-center progress-text"
            :style="{ position: 'absolute' }"
          >
            <h5 class="d-none d-lg-block" style="margin-top: 2px">
              <b-badge squared variant="dark-transparent"
                >Porcentaje de obra: {{ apartment.progress }}%</b-badge
              >
            </h5>
            <b-badge class="d-lg-none mt-2" squared variant="dark-transparent"
              >Porcentaje de obra: {{ apartment.progress }}%</b-badge
            >
          </div>
          <b-progress-bar
            variant="customer"
            class="rounded-0"
            :value="apartment.progress"
          ></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row
      v-if="
        features.length > 0 ||
        (apartment.progress && apartment.progress >= 0 && template == 'redondo')
      "
    >
      <b-col cols="12">
        <b-table-simple borderless class="mt-2 mb-0">
          <b-tr>
            <b-th colspan="2" style="font-size: 150%" class="pl-0">
              Características del proyecto
            </b-th>
          </b-tr>
        </b-table-simple>
      </b-col>
    </b-row>
    <b-row
      v-if="
        apartment.progress &&
        apartment.progress >= 0 &&
        ['redondo', 'cuadrado'].includes(template)
      "
    >
      <b-col cols="12">
        <p>Porcentaje de obra: {{ apartment.progress }}%</p>
        <b-progress :max="100" class="rounded-0 apartment-progress">
          <b-progress-bar
            variant="customer"
            class="rounded-0"
            :value="apartment.progress"
          ></b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row v-if="project">
      <b-col
        cols="12"
        lg="5"
        order-lg="0"
        v-if="!['cuadrado'].includes(template)"
      >
        <template v-if="images">
          <div @click="showPhoto2" v-if="images.length > 0">
            <b-carousel
              v-model="carouselPosition2"
              class="apartment-images my-4"
              :style="{ textShadow: '0px 0px 2px #000', minHeight: '100px' }"
              fade
              controls
            >
              <template v-if="images">
                <b-carousel-slide
                  v-for="(photo, key) in images"
                  :key="`photoshow${key}`"
                  v-bind:style="{
                    background:
                      'url(' +
                      photo.url
                        .trim()
                        .replace(/ /g, '%20')
                        .replace(/\(/g, '%28')
                        .replace(/\)/g, '%29') +
                      ')',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%',
                  }"
                ></b-carousel-slide>
              </template>
            </b-carousel>
            <div class="text-right small text-dark">
              <i>*Presiona en las fotos para verlas completas</i>
            </div>
            <b-modal
              id="modal-photo2"
              size="xl"
              :interval="0"
              centered
              hide-header
              body-bg-variant="transparent"
              content-class="border-0 bg-transparent"
              hide-footer
            >
              <b-carousel v-model="setedPhoto2" fade controls>
                <template v-if="images">
                  <b-carousel-slide
                    v-for="(photo, key) in images"
                    :img-src="photo.url"
                    :key="`photoshow${key}`"
                  ></b-carousel-slide>
                </template>
              </b-carousel>
            </b-modal>
          </div>
        </template>
      </b-col>
      <b-col
        cols="12"
        :lg="!['cuadrado'].includes(template) ? '7' : '12'"
        order-lg="1"
      >
        <template v-if="features.length > 0">
          <b-table-simple
            v-if="['redondo'].includes(template)"
            borderless
            class="mt-2"
          >
            <b-tr v-for="(feature, key) in features" :key="key">
              <b-td width="1%" class="align-middle text-center">
                <img
                  v-if="hasImage(feature)"
                  :id="`feature${feature.key}`"
                  :src="feature.urlLogoCaracteristica"
                  style="
                    height: 100%;
                    width: 100%;
                    min-height: 40px;
                    min-width: 40px;
                    max-height: 40px;
                    max-width: 40px;
                  "
                />
                <img
                  v-else
                  :id="`feature${feature.key}`"
                  :src="`/images/icons/${feature.descripcion}.png`"
                  @error="iconLoadError(feature)"
                  height="40px"
                />
              </b-td>
              <b-td>
                {{ feature.descripcion }}
              </b-td>
            </b-tr>
          </b-table-simple>
          <b-row
            v-else-if="['cuadrado'].includes(template)"
            class="mt-2"
            align-h="center"
          >
            <b-col
              lg="3"
              v-for="(feature, key) in features"
              :key="key"
              class="my-2"
            >
              <span width="1%" class="align-middle text-center pr-3">
                <img
                  v-if="hasImage(feature)"
                  :id="`feature${feature.key}`"
                  :src="feature.urlLogoCaracteristica"
                  style="
                    height: 100%;
                    width: 100%;
                    min-height: 40px;
                    min-width: 40px;
                    max-height: 40px;
                    max-width: 40px;
                  "
                />
                <font-awesome-icon
                  v-else
                  :icon="['fal', setIcon(feature)]"
                  size="2x"
                  class="text-customer"
                />
              </span>
              <span>{{
                feature.mostrarCategoriaTitulo
                  ? feature.categoria
                  : feature.descripcion
              }}</span>
            </b-col>
          </b-row>
          <b-table-simple v-else borderless class="mt-2">
            <b-tr v-for="(feature, key) in features" :key="key">
              <b-td width="1%" class="align-middle text-center">
                <img
                  v-if="hasImage(feature)"
                  :id="`feature${feature.key}`"
                  :src="feature.urlLogoCaracteristica"
                  style="
                    height: 100%;
                    width: 100%;
                    min-height: 40px;
                    min-width: 40px;
                    max-height: 40px;
                    max-width: 40px;
                  "
                />
                <font-awesome-icon
                  v-else
                  :icon="['fal', setIcon(feature)]"
                  size="2x"
                  class="text-customer"
                />
              </b-td>
              <b-td>
                {{
                  feature.mostrarCategoriaTitulo
                    ? feature.categoria
                    : feature.descripcion
                }}
              </b-td>
            </b-tr>
          </b-table-simple>
        </template>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import BuyProgress from "../../components/BuyProgress.vue";
export default {
  name: "showApartment",
  components: {
    BuyProgress,
  },
  props: {
    asset_id: { default: null },
    photos: { default: [] },
    images: { default: [] },
    features: { default: [] },
  },
  data() {
    return {
      apartment: {},
      selectedApartment: null,
      tab_index: null,
      carouselPosition: 0,
      setedPhoto: 0,
      carouselPosition2: 0,
      setedPhoto2: 0,
    };
  },
  mounted() {
    this.setApartment();
  },
  methods: {
    setApartment() {
      this.apartment = this.$store.getters.getApartmentById(
        parseInt(this.asset_id)
      );
    },
    setIcon(feature) {
      if (feature.urlLogoCaracteristica) {
        if (feature.urlLogoCaracteristica.length > 0) {
          return feature.urlLogoCaracteristica;
        }
      }
      switch (feature.categoria) {
        case "Areas Verdes":
          return "leaf";
        case "Areas comunes":
          return "dumbbell";
        case "Infraestructura":
          return "building";
        case "Característica departamento":
          return "door-closed";
        case "Espacios Utiles":
          return "garage-car";
        case "Plusvalía":
          return "chart-line";
        default:
          return "building";
      }
      //falLeaf, falDumbbell, falDoorClosed, falChartLine, falGarageCar
    },
    iconLoadError(feature) {
      document.getElementById(
        `feature${this.project.id}`
      ).src = require(`@/assets/images/icons/${feature.categoria}.png`);
    },
    showPhoto() {
      this.setedPhoto = this.carouselPosition;
      this.$root.$emit("bv::show::modal", "modal-photo");
    },
    showPhoto2() {
      this.setedPhoto2 = this.carouselPosition2;
      this.$root.$emit("bv::show::modal", "modal-photo2");
    },
    hideData(assetType) {
      return [
        "LOTE",
        "ESTACIONAMIENTO",
        "BODEGA",
        "SITIO",
        "BICICLETERO",
        "ACCION",
      ].includes(assetType);
    },
    hasImage(feature) {
      if (feature.urlLogoCaracteristica) {
        if (
          feature.urlLogoCaracteristica.length > 0 &&
          feature.urlLogoCaracteristica !=
            "https://s3.amazonaws.com/gestion.mobysuite/null"
        ) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    asset_id: {
      handler: function () {
        this.selected_tab = 0;
      },
    },
  },
  computed: {
    customer() {
      return this.$store.getters.getCustomer;
    },
    domain() {
      return this.$store.getters.getCustomerDomain;
    },
    project() {
      return this.$store.getters.getProjectByMoby(this.apartment.project_id);
    },
    address() {
      return this.project
        ? `${this.project.direccion.direccion}, ${this.project.direccion.comuna}`
        : "";
    },
    addressCountry() {
      return this.project
        ? `${this.project.direccion.ciudad} ${this.project.direccion.pais}`
        : "";
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
  },
};
</script>
<style scoped></style>
